module.exports = __webpack_public_path__ + "img/Vector2.2bde27e0.svg";